import { render } from "./B2bFiltersRecadvsEmit.vue?vue&type=template&id=54bbf230&scoped=true&lang=pug"
import script from "./B2bFiltersRecadvsEmit.vue?vue&type=script&lang=js"
export * from "./B2bFiltersRecadvsEmit.vue?vue&type=script&lang=js"

import "./B2bFiltersRecadvsEmit.vue?vue&type=style&index=0&id=54bbf230&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bbf230"]])

export default __exports__